<app-tab-navigation-header title="Property" i18n-title="@@propertyDetails-propertyTitle" detail="{{ propertyName }}">
	<mat-tab-group appQueryStringTabGroup appTabAutomationId [selectedIndex]="initialTabIndex">
		<mat-tab label="Details" i18n-label="@@property-detailsAbout" aria-label="details">
			<ng-template matTabContent>
				<app-property-about [appBreadcrumbLabel]="aboutBreadcrumbLabel" [propertyId]="propertyId"></app-property-about>
			</ng-template>
		</mat-tab>

		<mat-tab label="Devices" i18n-label="@@property-detailsDevices" aria-label="devices">
			<ng-template matTabContent>
				<app-all-devices
					[appBreadcrumbLabel]="devicesBreadcrumbLabel"
					[deviceDataRequest]="filteredDevicesByPropertyId"
				></app-all-devices>
			</ng-template>
		</mat-tab>

		@if (this.canViewClients) {
			<mat-tab label="Clients" i18n-label="@@property-detailsClients" aria-label="clients">
				<ng-template matTabContent>
					<app-client-list-table
						[propertyContext]="{ locationId: propertyId, propertyCompanyId: property.companyId }"
					></app-client-list-table>
				</ng-template>
			</mat-tab>
		}

		@if (this.canAccessEventHistory) {
			<mat-tab
				label="Access History"
				i18n-label="@@property-detailsAccessHistory"
				aria-label="access-history"
				class="grid-container"
				fxFlex="grow"
			>
				<ng-template matTabContent>
					<app-property-event-history
						[appBreadcrumbLabel]="eventHistoryBreadcrumbLabel"
						[propertyId]="propertyId"
						[viewingCompanyId]="viewingCompanyId"
					></app-property-event-history>
				</ng-template>
			</mat-tab>
		}

		@if (this.canAccessAuditLogs) {
			<mat-tab label="Audit Log" i18n-label="@@property-detailsAuditLog" aria-label="audit-log">
				<ng-template matTabContent>
					<app-audit-log-list
						[propertyId]="propertyId"
						[appBreadcrumbLabel]="auditLogBreadcrumbLabel"
						[hiddenColumns]="hiddenAuditLogColumns"
					></app-audit-log-list>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
